export default import.meta.ROLLDOWN_FILE_URL_jxmvnhfpiC2w3Y112DEmhw